import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--bg-section)',
      borderTop: '2px solid rgba(91, 127, 255, 0.2)',
      boxShadow: '0 -4px 24px rgba(31, 38, 135, 0.08)',
      paddingTop: '40px'
    }}>
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_eqjourney-1/artifacts/esi0kvor_ChatGPT%20Image%20Jan%2029%2C%202026%2C%2001_08_19%20PM.png"
              alt="Emotional Intelligence Academy"
              className="h-28 w-auto mb-4"
              style={{ maxWidth: '360px' }} />

            <p className="body-small text-text-secondary mb-4">
              A premium, parent-guided emotional skills curriculum. One book per age. 40 weeks of scripts and practice.
            </p>
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full hover:bg-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full hover:bg-white transition-colors">
                <Instagram size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full hover:bg-white transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-3 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/start-here" className="body-small hover:text-brand-primary transition-colors">
                  Books by Age
                </Link>
              </li>
              <li>
                <Link to="/series-overview" className="body-small hover:text-brand-primary transition-colors">
                  Overview
                </Link>
              </li>
              <li>
                <Link to="/blog" className="body-small hover:text-brand-primary transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="heading-3 mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="body-small hover:text-brand-primary transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/faq" className="body-small hover:text-brand-primary transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/admin" className="body-small hover:text-brand-primary transition-colors">
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="heading-3 mb-4">Stay Connected</h3>
            <p className="body-small text-text-secondary mb-4">
              Get free resources and parenting tips delivered to your inbox.
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2 rounded-full border border-border-input focus:border-border-input-focus outline-none text-sm" />

              <button className="btn-primary">
                <Mail size={18} />
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border-light">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="caption">
              © 2024 Emotional Intelligence Academy. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="caption hover:text-brand-orange transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="caption hover:text-brand-orange transition-colors">
                Terms of Use
              </Link>
            </div>
          </div>
          <p className="caption text-center md:text-left mt-4">
            Educational content only. Not a substitute for professional advice or treatment.
          </p>
        </div>
      </div>
    </footer>);

};

export default Footer;